import React from "react";

// Lot filter for case lists that mix lots. A lot is lot no + bank + product (the same lot no can exist for
// different banks), so each option shows all three: "Lot 7 - AVANSE PVT LTD - Education Loan".
// Rows carry the backend's lot fields lotKey / lotLabel (backend case/lotLabel.ts).
export const filterByLot = (rows, lot) => (lot ? rows.filter((row) => row.lotKey === lot) : rows);

const LotFilter = ({ rows, value, onChange }) => {
  const lots = [...new Map(rows.map((row) => [row.lotKey, row.lotLabel])).entries()];
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="form-select"
      style={{ maxWidth: "340px", fontSize: "0.8rem" }}
      aria-label="Lot"
    >
      <option value="">All lots</option>
      {lots.map(([key, label]) => (
        <option key={key} value={key}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default LotFilter;
